import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  CLEAR_PROFILE_ERROR
} from './profileActionTypes'

const initialState = {
  loading: false,    // For initial load
  updating: false,  // For update operations
  profile: null,
  error: null
}

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return { ...state, loading: true, error: null }
    case UPDATE_PROFILE_REQUEST:
      return { ...state, updating: true, error: null }
    case FETCH_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload, error: null }
    case UPDATE_PROFILE_SUCCESS:
      return { ...state, updating: false, profile: action.payload, error: null }
    case FETCH_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.error }
    case UPDATE_PROFILE_FAILURE:
      return { ...state, updating: false, error: action.error }
    case CLEAR_PROFILE_ERROR:
      return { ...state, error: null }
    default:
      return state
  }
}

export default profileReducer
